"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var routes = [{ loadChildren: './secure-form/secure-form-app.module' }, { loadChildren: './pre-chat/pre-chat-app.module' }];
var AppModule = /** @class */ (function () {
    function AppModule(injector, moduleLoader) {
        this.injector = injector;
        this.moduleLoader = moduleLoader;
    }
    AppModule.prototype.ngDoBootstrap = function (appRef) {
        var _this = this;
        var modules = document.querySelectorAll('[data-module-path]');
        for (var i in modules) {
            if (modules.hasOwnProperty(i)) {
                var modulePath = modules[i].getAttribute('data-module-path');
                if (modulePath) {
                    this.moduleLoader.load(modulePath)
                        .then(function (moduleFactory) {
                        var ngModuleRef = moduleFactory.create(_this.injector);
                        ngModuleRef.injector.get('components').forEach(function (components) {
                            components.forEach(function (component) {
                                var compFactory = ngModuleRef.componentFactoryResolver.resolveComponentFactory(component);
                                if (document.querySelector(compFactory.selector)) {
                                    appRef.bootstrap(compFactory);
                                }
                            });
                        });
                    });
                }
            }
        }
    };
    return AppModule;
}());
exports.AppModule = AppModule;
